<template>
  <div class="card">
    <div class="card-header">
      <h3>Chỉ số phát triển</h3>
    </div>
    <div class="box">
      <b-row>
        <b-col lg="6" xl="3">
          <a :href="linkDongHo" target="_blank">
            <div class="box__dongHo">
              <img src="../../../img/purple.svg" class="img-thongke" />
              <div class="d-flex align-items-center justify-content-between">
                <h4>Dòng họ</h4>
                <div class="box__icon"><i class="fas fa-users"></i></div>
              </div>
              <div class="box__content">
                <div class="box__content--title">
                  <countTo
                    :startVal="startVal"
                    :endVal="endVal_so_dong_ho"
                    :duration="2000"
                  ></countTo>
                </div>
              </div>
            </div>
          </a>
        </b-col>

        <b-col lg="6" xl="3">
          <a :href="linkThanhVienDongHo" target="_blank">
            <div class="box__node">
              <img src="../../../img/purple.svg" class="img-thongke" />
              <div class="d-flex align-items-center justify-content-between">
                <h4>Thành viên trong gia phả</h4>
                <div class="box__icon">
                  <i class="fas fa-chart-network"></i>
                </div>
              </div>

              <div class="box__content">
                <div class="box__content--title">
                  <countTo
                    :startVal="startVal"
                    :endVal="endVal_so_node_gia_pha_da_duyet"
                    :duration="2000"
                  ></countTo>
                </div>
              </div>
            </div>
          </a>
        </b-col>

        <b-col lg="6" xl="3">
          <div class="box__nguoiDung">
            <img src="../../../img/purple.svg" class="img-thongke" />
            <div class="d-flex align-items-center justify-content-between">
              <h4>Người dùng</h4>
              <div class="box__icon"><i class="fas fa-user"></i></div>
            </div>
            <div class="box__content">
              <div class="box__content--title">
                <countTo
                  :startVal="startVal"
                  :endVal="endVal_so_nguoi_dung_kich_hoat"
                  :duration="2000"
                ></countTo>
              </div>
            </div>
          </div>
        </b-col>

        <b-col lg="6" xl="3">
          <div class="box__soTinh" @click="showTopProvince">
            <img src="../../../img/purple.svg" class="img-thongke" />
            <div class="d-flex align-items-center justify-content-between">
              <h4>Tỉnh thành</h4>
              <div class="box__icon"><i class="fas fa-map-marked-alt"></i></div>
            </div>
            <div class="box__content">
              <div class="box__content--title">
                <countTo
                  :startVal="startVal"
                  :endVal="endVal_so_tinh"
                  :duration="2000"
                ></countTo>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <el-dialog
      title="xếp hạng tỉnh đăng ký dòng họ"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      align-center
    >
      <div class="header-info">
        <p>TỈNH/THÀNH PHỐ</p>
        <p>SỐ DÒNG HỌ</p>
      </div>
      <div class="top-province-block">
        <div
          v-for="(item, index) in this.arrayTopProvince"
          :key="item.id"
          class="top-province"
          :number="index + 1"
        >
          <el-tooltip
            class="item"
            popper-class="poper-name"
            effect="dark"
            :content="item.name"
            placement="top-start"
          >
            <span class="name-province">{{ item.name }}</span>
          </el-tooltip>

          <span>{{ item.count }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mushroom from "viettoc-api";
import countTo from "vue-count-to";
export default {
  data() {
    return {
      startVal: 0,
      endVal_so_dong_ho: 0,
      endVal_so_nguoi_dung_kich_hoat: 0,
      endVal_so_node_gia_pha_da_duyet: 0,
      endVal_so_tinh: 0,
      linkDongHo: "",
      linkThanhVienDongHo: "", // node gia phả
      linkNguoiDung: "",
      dialogVisible: false,
      arrayTopProvince: [],
    };
  },
  components: { countTo },
  methods: {
    showTopProvince() {
      console.log("show top");
      this.dialogVisible = true;
    },
    fn_getLink() {
      this.linkDongHo = location.origin + "/admin/dong-ho/danh-sach-dong-ho";
      this.linkThanhVienDongHo =
        location.origin + "/admin/node-gia-pha/danh-sach-node-gia-pha";
    },
    async fn_thongKe() {
      try {
        const chi_so = await mushroom.thong_ke.views.thong_ke_du_lieuAsync();
        console.log("Thông tin ldp_thong_ke trả về: %o", chi_so.result);
        this.endVal_so_dong_ho = chi_so.result[0].so_dong_ho;
        this.endVal_so_node_gia_pha_da_duyet =
          chi_so.result[0].so_node_gia_pha_da_duyet;
        this.endVal_so_nguoi_dung_kich_hoat =
          chi_so.result[0].so_nguoi_dung_kich_hoat;
        this.endVal_so_tinh = chi_so.result[0].so_tinh;
      } catch (e) {
        console.error("thong ke", e);
      }
    },
    async fn_thongKeSoLuongDongHo() {
      const arr = [];
      try {
        const response =
          await mushroom.dang_ky.views.thong_ke_so_luong_dong_hoAsync();
        if (response.result && response.result.length > 0) {
          response.result.forEach((item) => {
            arr.push({
              name: item.type + " " + item.name,
              count: item.count,
            });
          });
          arr.forEach((e) => {
            let checkInArrFi = this.arrayTopProvince.find((x) => {
              return x.count == e.count;
            });
            if (!checkInArrFi) {
              this.arrayTopProvince.push({
                count: e.count,
                name: e.name,
              });
            } else {
              checkInArrFi.name = `${checkInArrFi.name}, ${e.name}`;
            }
          });
        }
        console.log("Thông tin dang_ky trả về: %o", response);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
  },
  async created() {
    this.fn_getLink();
    await this.fn_thongKe();
    await this.fn_thongKeSoLuongDongHo();
  },
};
</script>

<style lang="scss">
.card {
  height: auto;
}
.box-style {
  position: relative;
  padding: 15px;
  align-items: center;
  border-radius: 5px;
  margin: 10px 0;
  justify-content: space-between;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px,
    rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
  min-height: 192px;
}
.icon-style {
  color: #fff;
  border-radius: 35px;
  font-size: 25px;
  display: flex;

  align-items: center;
  justify-content: center;
  height: 50px;
}
.box {
  padding: 20px;
  a {
    color: #4a4a4a;
    text-decoration: none;
  }

  h4 {
    color: rgb(255, 255, 255);
    font-weight: 600;
    text-align: start;
    font-size: 16px;
  }

  &__content {
    display: flex;
    justify-content: space-between;
    margin-top: 36px;
  }

  &__content--growth {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    text-align: end;
  }
  .box__dongHo {
    @extend .box-style;
    background: #f857a6;
    background: -webkit-linear-gradient(to right, #ff5858, #f857a6);
    background: linear-gradient(to right, #ff5858, #f857a6);
    .box__icon {
      @extend .icon-style;
    }
  }
  .box__nguoiDung {
    @extend .box-style;
    background: #26a8c9;
    background: -webkit-linear-gradient(to right, #26a8c9, #6dd5ed);
    background: linear-gradient(to right, #26a8c9, #6dd5ed);
    .box__icon {
      @extend .icon-style;
    }
  }
  .box__soTinh {
    @extend .box-style;
    background: #fdc830;
    background: -webkit-linear-gradient(to right, #f37335, #fdc830);
    background: linear-gradient(to right, #f37335, #fdc830);
    cursor: pointer;
    .box__icon {
      @extend .icon-style;
    }
  }
  .box__node {
    @extend .box-style;
    background: #9d50bb; /* fallback for old browsers */
    background: -webkit-linear-gradient(
      to right,
      #6e48aa,
      #9d50bb
    ); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(
      to right,
      #6e48aa,
      #9d50bb
    ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

    .box__icon {
      @extend .icon-style;
    }
  }

  &__content--title {
    color: #fff;
    font-size: 43px;
    font-weight: 800;
    text-align: end;
  }
}
.img-thongke {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  left: 0;
  object-fit: cover;
}
.top-province {
  padding: 10px 10px 10px 35px;
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
  position: relative;
}
.top-province::before {
  position: absolute;
  content: attr(number);
  left: 7px;
  top: 9px;
  font-size: 14px;
}
.top-province:nth-child(1),
.top-province:nth-child(2),
.top-province:nth-child(3) {
  font-weight: bold;
  left: -5px;
  padding-left: 40px;
}
.top-province:nth-child(1)::before,
.top-province:nth-child(2)::before,
.top-province:nth-child(3)::before {
  position: absolute;
  content: " ";
  left: 0px;
  top: 2px;
  height: 35px;
  width: 35px;
}
.top-province:nth-child(1)::before {
  background: url("../../../img/top1.png") no-repeat center center/cover;
}
.top-province:nth-child(2)::before {
  background: url("../../../img/top2.png") no-repeat center center/cover;
}
.top-province:nth-child(3)::before {
  background: url("../../../img/top3.png") no-repeat center center/cover;
}
.top-province-block {
  max-height: calc(85vh - 170px);
  overflow-x: hidden;
  overflow-y: auto;
}
.header-info {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  margin-bottom: 10px;
}
.name-province {
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* số dòng hiển thị */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 20px;
}
.poper-name {
  max-width: 400px;
}
</style>
